<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.operations_filter()">
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.operations.created_at') }}</label>
                    <DatePicker
                        v-model="filter.columns.created_duration"
                        format="YYYY-MM-DD"
                        type="daterange"
                        key="advanced_created_at"
                        :re_init="Boolean(filter.columns.created_duration)"
                    >
                    </DatePicker>
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.number') }}</label>
                    <input type="text"
                        v-model="filter.columns.number"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.your_note') }}</label>
                    <input type="text"
                        v-model="filter.columns.customer_note"
                    >
                </div>
            </div>
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.operations.original_file_name') }}</label>
                    <input type="text"
                        v-model="filter.columns.original_file_name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.operations.status') }}</label>
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" v-model="filter.columns.is_done">
                        <label>{{ $t('models.attributes.operations.is_done') }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.operations_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "OperationsFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.operations_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>

<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
</style>
<style scoped lang="scss">

</style>
